import React, { Suspense } from "react";

import ChunkErrorBoundary from "./ChunkErrorBoundary";
import PageLoader from "./PageLoader";
import PageLoadError from "./PageLoadError";

// Every lazily loaded page renders inside one of these: Suspense covers the chunk
// fetch, the boundary covers a chunk that never arrives.
const LazyBoundary = ({ children }: { children: React.ReactNode }) => (
  <ChunkErrorBoundary loadingFallback={<PageLoader />} errorFallback={<PageLoadError />}>
    <Suspense fallback={<PageLoader />}>{children}</Suspense>
  </ChunkErrorBoundary>
);

export default LazyBoundary;
